function successSend(data) {
    let res = data.trim();
    if (res === 'success') {
        if (!$('.toast').length) {
            $('body').append(`
                <div class="toast iyarn-toast" data-delay="8000">
                    <div class="toast-header">
                        <img decoding="async" loading="lazy" src="/wp-content/themes/iyarn/build/img/favicon.png" width="20" height="20" class="rounded-0 mr-2" alt="iyarn logo">
                        <strong class="mr-auto">iyarn</strong>
                        <button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="toast-body">
                        Thank you. Message sent successfully!
                    </div>
                </div>
            `);
            $('#feedbackModal').modal('hide');
            $('form').trigger('reset').removeClass('was-validated');
            $('.toast').toast('show');
            $('.toast').on('hidden.bs.toast', function () {
                $('.toast').remove();
            });
        }
    }
}
